import { Link, useParams } from "react-router-dom";

const COMPANY = {
  name: "BALECH Douglas — Kairos",
  siret: "109 820 811 00015",
  address: "Résidence La Caravelle, 1 ter chemin des Amoureux, 83990 Saint-Tropez, France",
  email: "Douglas.balech@gmail.com",
};

const S = ({ t, children }) => (
  <section className="mt-10">
    <h2 className="font-display text-2xl">{t}</h2>
    <div className="mt-3 space-y-3 text-base leading-relaxed text-[var(--muted)]">{children}</div>
  </section>
);

const Mentions = () => (
  <>
    <S t="Éditeur du site">
      <p>{COMPANY.name}<br />Entrepreneur individuel — SIREN 109 820 811 — SIRET {COMPANY.siret}<br />{COMPANY.address}<br />Contact : {COMPANY.email}</p>
      <p>N° de TVA intracommunautaire : FR05109820811</p>
      <p>Directeur de la publication : Douglas Balech</p>
    </S>
    <S t="Hébergement"><p>Site hébergé par Emergent (emergent.sh).</p></S>
    <S t="Liens partenaires">
      <p>Certains produits marqués « Partenaire » redirigent vers des marchands tiers (ex. Amazon). Kairos perçoit une commission sur les achats éligibles, sans surcoût pour vous.</p>
    </S>
    <S t="Propriété intellectuelle"><p>Les textes, le logo et la marque Kairos sont la propriété de l'éditeur. Toute reproduction sans autorisation est interdite.</p></S>
  </>
);

const Cgv = () => (
  <>
    <S t="1. Objet"><p>Les présentes conditions régissent les ventes conclues sur ce site entre {COMPANY.name} (SIRET {COMPANY.siret}) et tout client consommateur.</p></S>
    <S t="2. Prix"><p>Les prix sont indiqués en euros, toutes taxes comprises. Des frais de livraison de 4,90 € s'appliquent aux objets physiques pour toute commande inférieure à 60 €. Des frais de service de 1 € s'appliquent à chaque commande.</p></S>
    <S t="3. Paiement"><p>Le paiement s'effectue par carte bancaire (via Stripe) ou via PayPal. La commande est validée à réception du paiement.</p></S>
    <S t="4. Livraison"><p>Les objets physiques sont expédiés directement par nos fournisseurs partenaires. Sauf délai différent indiqué sur la fiche produit, la livraison intervient au plus tard 30 jours après la commande (art. L216-1 du Code de la consommation). Les produits numériques sont envoyés par email après confirmation du paiement.</p></S>
    <S t="5. Droit de rétractation">
      <p>Pour les objets physiques, vous disposez de 14 jours à compter de la réception pour vous rétracter (art. L221-18 du Code de la consommation). Contactez {COMPANY.email}.</p>
      <p>Pour les contenus numériques, en validant la commande vous demandez leur fourniture immédiate et renoncez expressément à votre droit de rétractation (art. L221-28 13°).</p>
    </S>
    <S t="6. Produits partenaires"><p>Les produits « Partenaire » sont vendus et expédiés par le marchand tiers, selon ses propres conditions.</p></S>
    <S t="7. Garanties"><p>Les objets bénéficient de la garantie légale de conformité (art. L217-3 et s. du Code de la consommation) et de la garantie des vices cachés (art. 1641 et s. du Code civil).</p></S>
    <S t="8. Réclamations et litiges">
      <p>Pour toute réclamation, écrivez à {COMPANY.email} en indiquant votre numéro de commande. Douglas Balech traite personnellement chaque demande et vous répond sous 7 jours ouvrés afin de trouver une solution amiable.</p>
      <p>Droit applicable : droit français.</p>
    </S>
  </>
);

const Privacy = () => (
  <>
    <S t="Responsable du traitement"><p>{COMPANY.name}, {COMPANY.address} — {COMPANY.email}</p></S>
    <S t="Données collectées">
      <p>Nom, email, adresse de livraison et contenu des commandes, ainsi que l'email pour la newsletter. Les données bancaires sont traitées uniquement par Stripe et PayPal ; nous n'y avons jamais accès.</p>
      <p>Si vous vous connectez avec Google, nous recevons votre nom, votre email et votre photo de profil.</p>
    </S>
    <S t="Finalités et durée"><p>Traitement et suivi des commandes (conservées 10 ans à des fins comptables), envoi de la newsletter (jusqu'à désinscription).</p></S>
    <S t="Vos droits"><p>Vous pouvez accéder à vos données, les rectifier ou les supprimer en écrivant à {COMPANY.email}. Vous pouvez aussi introduire une réclamation auprès de la CNIL (cnil.fr).</p></S>
    <S t="Cookies"><p>Le site utilise uniquement un cookie de session nécessaire à la connexion, ainsi qu'un stockage local pour votre panier.</p></S>
  </>
);

const PAGES = {
  "mentions-legales": ["Mentions légales", Mentions],
  cgv: ["Conditions générales de vente", Cgv],
  confidentialite: ["Politique de confidentialité", Privacy],
};

export default function Legal() {
  const { slug } = useParams();
  const [title, Body] = PAGES[slug] ?? PAGES["mentions-legales"];
  return (
    <div data-testid={`legal-page-${slug}`} className="mx-auto max-w-3xl px-5 pt-[120px] pb-10 sm:px-10">
      <Link to="/" className="text-sm text-[var(--muted)] hover:text-[var(--ink)]">← Accueil</Link>
      <h1 className="font-display mt-6 text-4xl sm:text-5xl font-light tracking-tight">{title}</h1>
      <Body />
    </div>
  );
}
